/**
 * VEEZE contact — deferred map embed.
 *
 * When the map block has "Ask before loading" on, the section renders the embed
 * URL in `data-map-embed` and no iframe at all, so nothing is requested from the
 * map host until the visitor presses the button. This builds the iframe on that
 * press. Relevant for a German shop: an embedded map contacts the host and
 * discloses the visitor's IP, which is what consent is normally required for.
 *
 * With JS off, the button simply does nothing and no data leaves the page — the
 * safe failure direction.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('.veeze-contact__map-load');
  if (!button) return;

  const holder = button.closest('[data-map-embed]');
  const src = holder?.dataset.mapEmbed;
  if (!src) return;

  const frame = document.createElement('iframe');
  frame.src = src;
  frame.title = holder.dataset.mapTitle || 'Karte';
  frame.loading = 'lazy';
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  frame.allowFullscreen = true;

  holder.textContent = '';
  holder.classList.remove('veeze-contact__map--gated');
  holder.appendChild(frame);
});
